import { Dropdown } from 'antd';
import type { DropdownProps } from 'antd';

export interface DDropdownProps extends DropdownProps {}

export const DarwinDropdown = (props: DDropdownProps) => {
  return <Dropdown {...props} />;
};
